<div class="d-flex justify-content-center">
  <div class="loader"></div>
</div>
